import React from 'react';
import { ContractingModule } from '@cropconnect/contracting-module';
import '@cropconnect/contracting-module/style.css';
// eslint-disable-next-line import/no-unresolved
import { SupportedLanguage } from '@cropconnect/contracting-module/dist/frontend/shared/src/config/localizationConfig';
import { Route, Routes } from 'react-router-dom';

import { useContextStore } from '../../stores/storeRoot';
import { convertToExternalLanguageCode } from '../../helpers/localeFormatter';
import PageHeader from '../../presentation/layout/PageHeader/PageHeader';
import { getDeploymentTarget } from '../../intergrations/fdtmAndContracting/environmentMapper';
import { FDTMContainer, FDTMPageContainer } from '../FDTMPage/styles';

const EContractingPage: React.FC = () => {
  const { activeBpNumber, selectedUserLanguage } = useContextStore();
  const numericBpNo = activeBpNumber ? parseInt(activeBpNumber, 10) : undefined;
  if (activeBpNumber && isNaN(numericBpNo!)) {
    console.error(
      'Failed to convert BP number to numeric value:',
      activeBpNumber
    );
    return;
  }
  const externalLanguage = convertToExternalLanguageCode(selectedUserLanguage);
  return (
    <FDTMPageContainer>
      <PageHeader title="" />
      <FDTMContainer>
        <Routes>
          <Route
            path="/*"
            element={
              <ContractingModule
                language={externalLanguage as SupportedLanguage}
                bpno={numericBpNo}
                baseRouterPath="/e-contracting"
                deploymentTarget={getDeploymentTarget()}
              />
            }
          />
        </Routes>
      </FDTMContainer>
    </FDTMPageContainer>
  );
};
export default EContractingPage;
